import { ReactNode } from "react";

import { useSignalR } from "../Hooks/useSignalR";
import SignalRContext, { SignalRContextType } from "../Contexts/SignalRContext";

interface SignalRProviderProps {
	hubUrl: string;
	children: ReactNode;
}

export const SignalRProvider: React.FC<SignalRProviderProps> = ({ hubUrl, children }) => {
	const { connection, isConnecting: isLoading, isReconnecting, error } = useSignalR(hubUrl);

	const value: SignalRContextType = {
		connection,
		isConnectionLoading: isLoading,
		isReconnecting,
		connectionError: error,
	};

	return <SignalRContext.Provider value={value}>{children}</SignalRContext.Provider>;
};